import { render, staticRenderFns } from "./InputSearchNews.vue?vue&type=template&id=797a3ecc&"
import script from "./InputSearchNews.vue?vue&type=script&lang=js&"
export * from "./InputSearchNews.vue?vue&type=script&lang=js&"
import style0 from "./InputSearchNews.vue?vue&type=style&index=0&id=797a3ecc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports